"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var context_1 = require("../context");
var theme_1 = require("../theme");
var pills_1 = require("./pills");
var Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    color: white;\n    flex-direction: row;\n    font-family: 'interface';\n    font-weight: 600;\n    font-size: 14px;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 10px;\n    ", "\n"], ["\n    display: flex;\n    color: white;\n    flex-direction: row;\n    font-family: 'interface';\n    font-weight: 600;\n    font-size: 14px;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 10px;\n    ", "\n"])), function (props) {
  return (0, theme_1.getSize)(props.theme);
});
var SuggestionBar = function SuggestionBar() {
  var _a = (0, react_1.useContext)(context_1.SearchContext),
    trendingSearches = _a.trendingSearches,
    currentChannels = _a.currentChannels;
  return react_1.default.createElement(Container, {
    className: SuggestionBar.className
  }, currentChannels.length > 0 ? currentChannels.map(function (channel) {
    return react_1.default.createElement(pills_1.ChannelPill, {
      key: channel.id,
      channel: channel
    });
  }) : trendingSearches.map(function (trendingSearch) {
    return react_1.default.createElement(pills_1.TrendingSearchPill, {
      key: trendingSearch,
      trendingSearch: trendingSearch
    });
  }));
};
SuggestionBar.className = 'giphy-suggestion-bar';
exports.default = SuggestionBar;
var templateObject_1;